document.addEventListener("DOMContentLoaded", function () {

  if (!window.location.pathname.includes("dental-paketinizi-kendiniz-hazirlayin"))
    return;

  const EXCHANGE_RATE = 54;

  // KDV'si %10 olan ürünler (adında geçen). Diğerleri %20.
  const KDV_10_URUNLER = [/crown[\s-]*tec/i, /denture[\s-]*tec/i];

  let stabilizeTimer = null;
  let lastAppliedEFTBase = null; // EFT indiriminin iki kez eklenmesini engeller

  // ------------------------------------------------------------
  // MUTATION OBSERVER → DOM stabilize olunca 1 kez updateEverything()
  // ------------------------------------------------------------
  const observer = new MutationObserver(() => {
    clearTimeout(stabilizeTimer);
    stabilizeTimer = setTimeout(() => updateEverything(), 200);
  });

  function izle() {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  izle();

  // ------------------------------------------------------------
  // UTILS
  // ------------------------------------------------------------
  // "1.234,56 ₺" ve "1,234.56 ₺" ikisini de okur
  function parseTL(v) {
    let s = v.replace(/[^\d.,]/g, "");
    const lc = s.lastIndexOf(","), ld = s.lastIndexOf(".");
    if (lc > ld) {
      s = (ld === -1 && s.length - lc - 1 === 3)
        ? s.replace(/,/g, "")
        : s.replace(/\./g, "").replace(",", ".");
    } else {
      s = (lc === -1 && ld !== -1 && s.length - ld - 1 === 3)
        ? s.replace(/\./g, "")
        : s.replace(/,/g, "");
    }
    return parseFloat(s);
  }

  function kdvOrani(metin) {
    return KDV_10_URUNLER.some(r => r.test(metin || "")) ? 0.10 : 0.20;
  }

  // netTL: KDV hariç TL. oran null ise sepette karışık oran var.
  function formatEUR(netTL, oran) {
    const eur = (netTL / EXCHANGE_RATE).toLocaleString("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2
    });
    return oran == null
      ? `${eur} + KDV`
      : `${eur} + KDV (%${Math.round(oran * 100)})`;
  }

  // Elemanın ait olduğu ürün kutusu: başka fiyat içermeyen en geniş kapsayıcı
  function urunKutusu(el, selector) {
    let k = el;
    while (k.parentElement && k.parentElement !== document.body &&
           k.parentElement.querySelectorAll(selector).length <= 1) {
      k = k.parentElement;
    }
    return k;
  }

  function isLastStep() {
    return document.querySelector(".summaryTotal__aa78b1") !== null;
  }

  function urunSatirlari() {
    return Array.from(document.querySelectorAll(".summaryRow__aa78b1"))
      .filter(r => !r.classList.contains("eft-discount-row"));
  }

  function satirTutari(row) {
    const span = row.querySelector("span:last-child span, span:last-child");
    return span ? parseTL(span.textContent.trim()) : NaN;
  }

  // Özet satırlarından: toplamın KDV hariç katsayısı ve tek oran (karışıksa null)
  function sepetKdv() {
    let brut = 0, net = 0;
    const oranlar = new Set();
    urunSatirlari().forEach(row => {
      const tl = satirTutari(row);
      if (isNaN(tl)) return;
      const oran = kdvOrani(row.textContent);
      brut += tl;
      net += tl / (1 + oran);
      oranlar.add(oran);
    });
    if (!brut) return { netKatsayi: 1 / 1.20, oran: 0.20 };
    return {
      netKatsayi: net / brut,
      oran: oranlar.size === 1 ? [...oranlar][0] : null
    };
  }

  // ------------------------------------------------------------
  // PRODUCT CARD EUR (HER ADIMDA)
  // ------------------------------------------------------------
  function updateCardPrices() {
    const SEL = 'div[data-settings="Product Card-1:product-card-price"]';

    document.querySelectorAll(SEL).forEach(c => {
      const span = c.querySelector("span:first-child");
      if (!span) return;

      c.querySelector(".usd-price")?.remove();

      const tl = parseTL(span.textContent.trim());
      if (isNaN(tl) || !tl) return;

      const oran = kdvOrani(urunKutusu(c, SEL).textContent);

      const d = document.createElement("div");
      d.className = "usd-price";
      d.style = "font-size:13px;color:gray;margin-top:3px;";
      d.textContent = formatEUR(tl / (1 + oran), oran);

      c.appendChild(d);
    });
  }

  // ------------------------------------------------------------
  // MINI SUMMARY EUR (HER ADIMDA)
  // ------------------------------------------------------------
  function updateSummaryUSD() {

    document.querySelectorAll(".usd-mini-summary").forEach(el => el.remove());

    urunSatirlari().forEach(row => {
      const tl = satirTutari(row);
      if (isNaN(tl) || !tl) return;

      const oran = kdvOrani(row.textContent);

      const d = document.createElement("div");
      d.className = "usd-mini-summary";
      d.style = `
        width:100%;
        display:flex;
        justify-content:flex-end;
        font-size:11px;
        color:#777;
        margin:3px 0 6px 0;
      `;
      d.textContent = formatEUR(tl / (1 + oran), oran);

      row.insertAdjacentElement("afterend", d);
    });

    // --- SON ADIM TOPLAM (büyük EUR)
    const total = document.querySelector(".summaryTotal__aa78b1");
    if (total) {

      if (total.nextElementSibling?.classList.contains("usd-summary"))
        total.nextElementSibling.remove();

      const span = total.querySelector("span:last-child span");
      if (!span) return;

      const tl = parseTL(span.textContent.trim());
      if (isNaN(tl) || !tl) return;

      const { netKatsayi, oran } = sepetKdv();

      const d = document.createElement("div");
      d.className = "usd-summary";
      d.style = `
        width:100%;
        display:flex;
        justify-content:flex-end;
        font-size:12px;
        color:#444;
        margin:4px 0 8px 0;
      `;
      d.textContent = formatEUR(tl * netKatsayi, oran);

      total.insertAdjacentElement("afterend", d);
    }
  }

  // ------------------------------------------------------------
  // SIDEBAR EUR (stable, flicker-free)
  // ------------------------------------------------------------
  function updateSidebarUSD() {
    const fpSpan = document.querySelector(".finalPrice__aa78b1 span");
    const fpBox  = document.querySelector(".finalPrice__aa78b1");
    if (!fpSpan || !fpBox) return;

    const tl = parseTL(fpSpan.textContent.trim());
    if (isNaN(tl) || !tl) return;

    const { netKatsayi, oran } = sepetKdv();
    const metin = formatEUR(tl * netKatsayi, oran);

    let usdEl = fpBox.querySelector(".usd-sidebar");

    // Eğer zaten varsa → sadece text güncelle (DOM ekleme yok → flicker yok)
    if (usdEl) {
      if (usdEl.textContent !== metin) usdEl.textContent = metin;
      return;
    }

    usdEl = document.createElement("div");
    usdEl.className = "usd-sidebar";
    usdEl.style = "font-size:12px;color:#ddd;margin-top:4px;";
    usdEl.textContent = metin;

    fpBox.appendChild(usdEl);
  }

  // ------------------------------------------------------------
  // %13 EFT İNDİRİMİ (ONLY LAST STEP, NO DUPLICATION)
  // ------------------------------------------------------------
  function updateEFTDiscount() {

    if (!isLastStep()) {
      lastAppliedEFTBase = null;
      document.querySelector(".eft-discount-row")?.remove();
      return;
    }

    const eftSelected = Array.from(
      document.querySelectorAll(".spInfoWrapper__aa78b1 span")
    ).some(el => el.textContent.includes("Havale/EFT"));

    const totalSpan = document.querySelector(".summaryTotal__aa78b1 span span");
    if (!totalSpan) return;

    let originalBase = parseTL(totalSpan.textContent.trim());
    if (isNaN(originalBase)) return;

    // Eğer zaten indirim uygulanmışsa → eski toplamı geri bul
    const existingDiscount = document.querySelector(".eft-discount-row");
    if (existingDiscount) {
      const discountValue = parseTL(existingDiscount.querySelector("span:last-child").textContent);
      originalBase = originalBase + discountValue;
    }

    if (!eftSelected) {
      document.querySelector(".eft-discount-row")?.remove();
      lastAppliedEFTBase = null;
      return;
    }

    // Bu toplam için EFT zaten uygulandı mı?
    if (lastAppliedEFTBase === originalBase) return;

    // %13 indirimi uygula
    const indirim = originalBase * 0.13;
    const yeniToplam = originalBase - indirim;

    totalSpan.textContent =
      yeniToplam.toLocaleString("tr-TR", { minimumFractionDigits: 2 }) + " ₺";

    document.querySelector(".eft-discount-row")?.remove();

    // Son ürün satırının altına ekle
    const rows = urunSatirlari();
    const lastRow = rows[rows.length - 1];
    if (!lastRow) return;

    const row = document.createElement("div");
    row.className = "summaryRow__aa78b1 eft-discount-row";
    row.style = `
      font-size:12px;color:#444;
      display:flex;justify-content:space-between;
      margin-bottom:6px;
    `;
    row.innerHTML = `
      <span>Havale/EFT indirimi (%13)</span>
      <span>- ${indirim.toLocaleString("tr-TR",{minimumFractionDigits:2})} ₺</span>
    `;

    lastRow.insertAdjacentElement("afterend", row);

    lastAppliedEFTBase = originalBase;
  }

  // ------------------------------------------------------------
  // REDIRECT
  // ------------------------------------------------------------
  function setupSubmitRedirect() {
    document.querySelectorAll(".bottomCta__aa78b1").forEach(btn => {
      if (btn.textContent.trim().includes("İletişime Geç")) {
        btn.onclick = e => {
          e.preventDefault();
          window.location.href = "https://dental.3dream.com.tr/pages/iletisim";
        };
      }
    });
  }

  // ------------------------------------------------------------
  // MASTER UPDATE
  // ------------------------------------------------------------
  // Kendi DOM değişikliklerimiz gözlemciyi tekrar tetiklemesin diye
  // güncelleme sırasında izleme durdurulur.
  function updateEverything() {
    observer.disconnect();
    try {
      updateEFTDiscount();   // önce indirim → EUR toplamı indirimli tutardan hesaplanır
      updateCardPrices();
      updateSummaryUSD();
      updateSidebarUSD();
      setupSubmitRedirect();
    } finally {
      izle();
    }
  }

});
